import { render, staticRenderFns } from "./inventory_show.vue?vue&type=template&id=05d81564&scoped=true&"
import script from "./inventory_show.vue?vue&type=script&lang=js&"
export * from "./inventory_show.vue?vue&type=script&lang=js&"
import style0 from "./inventory_show.vue?vue&type=style&index=0&id=05d81564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d81564",
  null
  
)

export default component.exports